export default "__VITE_ASSET__Dc__kotM__"